import { PropsWithChildren, memo } from 'react'

import { Box } from '@mui/material'
import { Outlet } from '@tanstack/react-router'

const DashboardSkeletonRaw = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        maxWidth: (theme) => theme.breakpoints.values.xl,
        mx: 'auto',
        width: '100%',
        // Fill the scroll container's height so descendants can opt into full height
        // (e.g. the event dashboard's edit mode) while content still scrolls when taller.
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {children ?? <Outlet />}
    </Box>
  )
}

export const DashboardSkeleton = memo(DashboardSkeletonRaw)
